import React from 'react';
export function SectionLabel({
  children
}: {
  children: React.ReactNode;
}) {
  return <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-emerald-500" data-id="element-532" data-mp="3c5z9blj8w4iw">
      <span className="h-px w-6 bg-emerald-500/60" aria-hidden="true" data-id="element-533" data-mp="2yfch8c7zpcvs" />
      {children}
    </p>;
}